enum EGobeletType {
    BIG = 'cup_50',
    SMALL = 'cup_33',
}

export { EGobeletType };
